<template>
  <div class="home">
    <main-carousel></main-carousel>

    <section class="container pt-3 pt-md-4">
      <section class="row">
        <main-box img-src="@/assets/images/accident.jpg" title="Naprawy powypadkowe">
          <template #intro>
            Wykonujemy naprawy powypadkowe, głównie obejmujące prace blacharsko-lakiernicze
            samochodów.
          </template>
          <p>
            Powierzając nam swoje auto mają Państwo pewność, że znajdzie się ono w dobrych rękach.
            Zapraszamy do bezpośredniej wizyty w warsztacie w Warszawie lub do kontaktu pod numerem
            telefonu
            <a href="tel:+48790025244">790 025 244</a>. Profesjonalnie obsługujemy klientów z
            Warszawy i okolic, a także z całej Polski.
          </p>
          <div class="text-center">
            <router-link :to="{ name: 'post-crash-repairs' }" class="btn btn-primary"
              >Czytaj więcej</router-link
            >
          </div>
        </main-box>

        <main-box img-src="@/assets/images/agreement.jpg" title="Naprawy bezgotówkowe">
          <template #intro>
            Realizujemy naprawy bezgotówkowe oraz reprezentujemy Klientów przed firmami
            ubezpieczeniowymi.
          </template>
          <p>
            Jedyną rzeczą, którą muszą Państwo wykonać jest zgłoszenie szkody do swojego towarzystwa
            ubezpieczeniowego, a jeśli jest to dla Państwa problemem: zrobimy to za was! Całą resztę
            spraw związanych z procedurą likwidacji szkody wykona nasz warsztat.
          </p>
          <div class="text-center">
            <router-link :to="{ name: 'cashless-repairs' }" class="btn btn-primary"
              >Czytaj więcej</router-link
            >
          </div>
        </main-box>

        <main-box img-src="@/assets/images/car-service1.jpg" title="Diagnostyka i&nbsp;serwis">
          <template #intro>
            Oferujemy serwis oraz diagnostykę samochodów osobowych. Posiadamy najnowsze i
            specjalistyczne urządzenia diagnostyczno-pomiarowe.
          </template>
          <p>
            Utrzymamy Państwa pojazd w należytym stanie technicznym wykonując przegląd, diagnosytkę
            komputerową, wymianę płynów oraz części eksploatacyjnych.
          </p>
          <div class="text-center">
            <router-link :to="{ name: 'service-diagnostics' }" class="btn btn-primary"
              >Czytaj więcej</router-link
            >
          </div>
        </main-box>

        <main-box img-src="@/assets/images/car-crashed.jpg" title="Skup aut powypadkowych">
          <template #intro>
            Rozbite, powypadkowe, uszkodzone samochody to niewątpliwie duży problem. Możemy go
            rozwiązać i odkupić Twój pojazd za gotówkę.
          </template>
          <p>
            W celu dokonania wyceny wartości swojego samochodu, wystarczy skontaktować się z nami i
            odwiedzić nasz warsztat. Zajmiemy się wszystkimi formalnościami i sporządzimy umowę
            kupna-sprzedaży.
          </p>
        </main-box>
      </section>
    </section>

    <section class="contact bg-primary text-light py-md-3">
      <div class="container-md">
        <div class="row">
          <div class="col-md-7 col-lg-8 col-xl-9 mb-2 mb-md-0">
            <div class="google-maps">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5030.240777086335!2d20.960663244654757!3d52.23394141691138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecb92afce1ea9%3A0xf52288e04de5e033!2sAUTO%20PS%20-%20Naprawy%20blacharsko%20-%20lakiernicze!5e0!3m2!1spl!2spl!4v1641763684121!5m2!1spl!2spl"
                width="600"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
          <div class="col-md text-center text-md-right align-self-center">
            <div class="mb-2">
              <p class="mb-0">
                <a href="tel:+48790025244" class="text-light text-nowrap">
                  <i class="fa fa-phone fa-fw"></i>
                  (+48) 790-025-244
                </a>
              </p>
              <p class="mb-0">
                <a href="mailto:autops.syreny14@gmail.com" class="text-light text-nowrap">
                  <i class="fa fa-envelope-o fa-fw"></i>
                  autops.syreny14@gmail.com
                </a>
              </p>
            </div>
            <p>
              Auto-PS<br />
              ul. Syreny 14, lok. 06<br />
              01-132 Warszawa<br />
              NIP: 524-172-34-87<br />
              REGON: 381274682
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import MainBox from '@/components/main-box.vue';
import MainCarousel from '@/components/main-carousel.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HomePage',
  components: {
    MainBox,
    MainCarousel,
  },
});
</script>

<style lang="scss" scoped>
.google-maps {
  position: relative;
  height: 0;
  overflow: hidden;

  padding-bottom: 56%;
  @include media-breakpoint-up(sm) {
    padding-bottom: 52%;
  }
  @include media-breakpoint-up(xl) {
    padding-bottom: 38%;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
}

.contact {
  .container-md {
    padding-left: 0;
    padding-right: 0;

    @include media-breakpoint-up(md) {
      padding-left: $grid-gutter-width / 2;
      padding-right: $grid-gutter-width / 2;
    }
  }
}
</style>
